import React from "react";
import WeatherData from "./Components/WeatherData";

const App = () => {
  return (
    <>
      <WeatherData />    
    </>
  )
}

export default App